import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ThemeState {
  isDarkMode: boolean;
}

// Get initial theme from localStorage or default to false
const getInitialTheme = (): boolean => {
  const savedTheme = localStorage.getItem('theme');
  return savedTheme === 'dark';
};

const initialState: ThemeState = {
  isDarkMode: getInitialTheme(),
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setDarkMode: (state, action: PayloadAction<boolean>) => {
      state.isDarkMode = action.payload;
    },
  },
});

export const { setDarkMode } = themeSlice.actions;
export default themeSlice.reducer; 